import Dialog from '@/components/Dialog';
import FormattedText from '@/components/FormattedText';
import { type Tag } from '@/lib/types';
import { IconButton } from '@mui/material';
import { useState } from 'react';
import { InfoOutlined as InfoIcon } from '@mui/icons-material';

type TagInfoProps = {
  tag: Tag;
};

const TagInfo = ({ tag }: TagInfoProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <IconButton edge="end" size="small" onClick={() => setDialogOpen(true)}>
        <InfoIcon fontSize="small" />
      </IconButton>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <Dialog.Title>{tag.name}</Dialog.Title>
        <Dialog.Content>
          <Dialog.ContentText>
            <FormattedText>{tag.info!}</FormattedText>
          </Dialog.ContentText>
        </Dialog.Content>
        <Dialog.Actions>
          <Dialog.Actions.DoneButton onClick={() => setDialogOpen(false)} />
        </Dialog.Actions>
      </Dialog>
    </>
  );
};

export default TagInfo;
